import {
  createPolicy as publicCreatePolicy,
  getPolicy as publicGetPolicy,
  updatePolicy as publicUpdatePolicy,
} from './restaurants-order-pacing-v1-policy-order-pacing-policy.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onPolicyCreated as publicOnPolicyCreated } from './restaurants-order-pacing-v1-policy-order-pacing-policy.public.js';
import { onPolicyUpdated as publicOnPolicyUpdated } from './restaurants-order-pacing-v1-policy-order-pacing-policy.public.js';

export const createPolicy: MaybeContext<
  BuildRESTFunction<typeof publicCreatePolicy> & typeof publicCreatePolicy
> = /*#__PURE__*/ createRESTModule(publicCreatePolicy);
export const getPolicy: MaybeContext<
  BuildRESTFunction<typeof publicGetPolicy> & typeof publicGetPolicy
> = /*#__PURE__*/ createRESTModule(publicGetPolicy);
export const updatePolicy: MaybeContext<
  BuildRESTFunction<typeof publicUpdatePolicy> & typeof publicUpdatePolicy
> = /*#__PURE__*/ createRESTModule(publicUpdatePolicy);
/** */
export const onPolicyCreated: BuildEventDefinition<
  typeof publicOnPolicyCreated
> = createEventModule(publicOnPolicyCreated);
/** */
export const onPolicyUpdated: BuildEventDefinition<
  typeof publicOnPolicyUpdated
> = createEventModule(publicOnPolicyUpdated);

export {
  Type,
  SyncLocationsSource,
  WebhookIdentityType,
} from './restaurants-order-pacing-v1-policy-order-pacing-policy.universal.js';
export {
  Policy,
  PolicyRule,
  WeeklyTimeInterval,
  ExtendedFields,
  CreatePolicyRequest,
  CreatePolicyResponse,
  GetPolicyRequest,
  GetPolicyResponse,
  UpdatePolicyRequest,
  UpdatePolicyResponse,
  RestaurantLocationsUpdatedEvent,
  RestaurantLocationProperties,
  SpecialEvent,
  Empty,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  BaseEventMetadata,
  EventMetadata,
  PolicyCreatedEnvelope,
  PolicyUpdatedEnvelope,
  GetPolicyOptions,
  UpdatePolicy,
} from './restaurants-order-pacing-v1-policy-order-pacing-policy.universal.js';
